import React, { useState, useEffect } from 'react'
import './AdvServiceMainSection.css'
import { GetServiceDept } from '../../api/api'
import { Outlet, useNavigate } from 'react-router-dom'
const AdvServiceMainSection = () => {

  const [serviceDept, setServiceDept] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const nevigate = useNavigate();


  // call GetServiceDept api  


  useEffect(() => {
    fetchServiceDept();
  }, []);

  const fetchServiceDept = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e"
    }
    try {
      setLoading(true);
      const res = await GetServiceDept(payload);
      if (res?.data?.status === "success") {
        const apiData = res?.data?.data || [];
        if (apiData.length > 0) {
          setServiceDept(apiData);
          console.log("apiData response ====>", apiData);

          setMessage("");
        } else {
          setServiceDept([]);
          setMessage("No data found");
        }
      } else {
        setMessage("Problem on API");
        setServiceDept([]);
      }
    } catch (error) {
      console.error("Error fetching service Dept:", error);
      setMessage("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
const showBranch = (deptItem) => {
  const deptDataString = encodeURIComponent(JSON.stringify(deptItem));
  nevigate(`/service/advServiceBookng/adv-branch/${deptDataString}`);
}

  return (
    <>
      <div className="adv-service-section">
        <div className="adv-grid-container">
          {serviceDept.map((item, index) => (
            <div className="adv-service-card" key={index}>
              <h3 className="adv-service-card-title">{item.Dept}</h3>
              <p className="adv-service-card-desc">Average Time Taken : {item.Service_Avg_TimeTaken_Mins} Minutes</p>

              <button
                className="adv-show-branch-btn"
                onClick={() => showBranch(item)}
              >
                show Branch &gt;
              </button>
            </div>
          ))}
        </div>
      </div>


    </>
  )
}
export default AdvServiceMainSection;
